import React from "react";
import colorsStore from "shared/store/colorsStore";
import {
  formatNumber,
  formatNumber3,
  formatPercentage,
  formatPercentageNo100,
} from "utils/formatUtils";
import { riskProfileMapEngToIta } from "utils/misc";
import styles from "./caratteristicheDiPortafoglio.module.scss";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "shared/components/ui/tooltip";
import { QuestionMarkIcon } from "shared/assets/svg/QuestionMarkIcon";

type SectionChildrenProps = {
  data: any;
};
const CaratteristicaDiPortafoglio: React.FC<SectionChildrenProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  if (!data) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      <div
        className={styles.gridContainer}
        style={{ color: colorsConfig.finecoBlack }}
      >
        <Caratteristica
          title={t("portfolio.rendimentoAtteso")}
          value={": " + formatPercentage(data?.return)}
        />

        <Caratteristica
          title={t("portfolio.dividendYield1y")}
          value={": " + formatPercentage(data?.dividend_yield)}
        />
        <Caratteristica
          title={t("portfolio.ratingEsgFineco")}
          value={": " + formatNumber(data?.esg)}
        />
        <Caratteristica
          title={t("portfolio.var")}
          value={": " + formatPercentage(data?.var)}
        />
        <Caratteristica
          title={t("portfolio.ytm")}
          value={": " + formatPercentageNo100(data?.ytm)}
        />
        <Caratteristica
          title={t("portfolio.finalScore")}
          value={": " + formatNumber(data?.final_score)}
        />
        <Caratteristica
          title={t("portfolio.sharpe")}
          value={": " + formatNumber3(data?.sharpe)}
        />
        <Caratteristica
          title={t("portfolio.duration")}
          value={": " + formatNumber(data?.duration) + " anni"}
        />
        <Caratteristica
          title={t("portfolio.finalScoreAdvice")}
          value={": " + formatNumber(data?.final_score_advice)}
        />
        {data?.financial_plan && (
          <Caratteristica
            title={t("portfolio.pianoFinanziario")}
            value={": " + data?.financial_plan}
          />
        )}
        <Caratteristica
          title={t("portfolio.costiStrumenti")}
          value={": " + formatPercentage(data?.total_cost)}
          description={t("portfolio.costiStrumentiDescription")}
        />
        {data?.risk_profile && (
          <Caratteristica
            title={t("portfolio.profiloDiRischio")}
            value={": " + riskProfileMapEngToIta(data?.risk_profile)}
          />
        )}
      </div>
    </div>
  );
};
export default React.memo(
  CaratteristicaDiPortafoglio,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.data === nextProps.data;
  },
);

type StatProps = {
  title: string;
  value: string;
  description?: string;
};

const Caratteristica: React.FC<StatProps> = ({ title, value, description }) => {
  return (
    <div className={styles.statsTitle}>
      {title}

      {description && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <div className={styles.infoIcon}>
                <QuestionMarkIcon viewBox="0.5 0.5 17 17" />
              </div>
            </TooltipTrigger>
            <TooltipContent>{description}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      <span className={styles.statsValue}>{value}</span>
    </div>
  );
};
